import React from "react";
import { useTranslation } from "react-i18next";

export default function NotAuth() {
	const { t } = useTranslation();

	return (
		<div className="widget__body widget--bets__empty">
			<i className="u-icon u-icon--huge u-icon--empty--bets u-mar--bottom--xsml" />
			<div className="u-type--center">
				{t<string>("COMMON.MY_BETS_NOT_AUTH")}
			</div>
		</div>
	);
}
